/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 * 
 * 
 * Hacked to handle external cross-domain stylesheets in Safari
 * 2015/12/28 - sgruenholz
 * 
 */
;
(function() {
    /**
     *
     * @type {Function}
     * @constructor
     */
    var ElementQueries = this.ElementQueries = function() {
        var _this = this;

        this.withTracking = false;
        this.elements = [];
        this.styleSheets = [];   // an array of external stylesheet urls
        this.loading = [];       // same as above but keeps track of stylesheets we are injecting

        /**
         *
         * @param element
         * @returns {Number}
         */
        this.getEmSize = function(element) {
            if (!element) {
                element = document.documentElement;
            }
            var fontSize = getComputedStyle(element, 'fontSize');
            return parseFloat(fontSize) || 16;
        };

        /**
         *
         * @copyright https://github.com/Mr0grog/element-query/blob/master/LICENSE
         *
         * @param {HTMLElement} element
         * @param {*} value
         * @returns {*}
         */
        this.convertToPx = function(element, value) {
            var units = value.replace(/[0-9]*/, '');
            value = parseFloat(value);
            switch (units) {
                case "px":
                    return value;
                case "em":
                    return value * _this.getEmSize(element);
                case "rem":
                    return value * _this.getEmSize();
                // Viewport units!
                // According to http://quirksmode.org/mobile/tableViewport.html
                // documentElement.clientWidth/Height gets us the most reliable info
                case "vw":
                    return value * document.documentElement.clientWidth / 100;
                case "vh":
                    return value * document.documentElement.clientHeight / 100;
                case "vmin":
                case "vmax":
                    var vw = document.documentElement.clientWidth / 100;
                    var vh = document.documentElement.clientHeight / 100;
                    var chooser = Math[units === "vmin" ? "min" : "max"];
                    return value * chooser(vw, vh);
                default:
                    return value;
                // for now, not supporting physical units (since they are just a set number of px)
                // or ex/ch (getting accurate measurements is hard)
            }
        };

        /**
         *
         * @param {HTMLElement} element
         * @constructor
         */
        function SetupInformation(element) {
            this.element = element;
            this.options = {};
            var key, option, width = 0, height = 0, value, actualValue, attrValues, attrValue, attrName;

            /**
             * @param {Object} option {mode: 'min|max', property: 'width|height', value: '123px'}
             */
            this.addOption = function(option) {
                var idx = [option.mode, option.property, option.value].join(',');
                this.options[idx] = option;
            };

            var attributes = ['min-width', 'min-height', 'max-width', 'max-height'];

            /**
             * Extracts the computed width/height and sets to min/max- attribute.
             */
            this.call = function() {
                // extract current dimensions
                width = this.element.offsetWidth;
                height = this.element.offsetHeight;

                attrValues = {};

                for (key in this.options) {
                    if (!this.options.hasOwnProperty(key)){
                        continue;
                    }
                    option = this.options[key];

                    value = _this.convertToPx(this.element, option.value);

                    actualValue = option.property == 'width' ? width : height;
                    attrName = option.mode + '-' + option.property;
                    attrValue = '';

                    if (option.mode == 'min' && actualValue >= value) {
                        attrValue += option.value;
                    }

                    if (option.mode == 'max' && actualValue <= value) {
                        attrValue += option.value;
                    }

                    if (!attrValues[attrName]) attrValues[attrName] = '';
                    if (attrValue && -1 === (' '+attrValues[attrName]+' ').indexOf(' ' + attrValue + ' ')) {
                        attrValues[attrName] += ' ' + attrValue;
                    }
                }

                for (var k in attributes) {
                    if (attrValues[attributes[k]]) {
                        this.element.setAttribute(attributes[k], attrValues[attributes[k]].substr(1));
                    } else {
                        this.element.removeAttribute(attributes[k]);
                    }
                }
            };
        };

        /**
         * @param {HTMLElement} element
         * @param {Object}      options
         */
        this.setupElement = function(element, options) {
            if (element.elementQueriesSetupInformation) {
                element.elementQueriesSetupInformation.addOption(options);
            } else {
                element.elementQueriesSetupInformation = new SetupInformation(element);
                element.elementQueriesSetupInformation.addOption(options);
                element.elementQueriesSensor = new ResizeSensor(element, function() {
                    element.elementQueriesSetupInformation.call();
                });
            }
            element.elementQueriesSetupInformation.call();

            if (ElementQueries.instance.withTracking && _this.elements.indexOf(element) < 0) {
                _this.elements.push(element);
            }
        };

        /**
         * @param {String} selector
         * @param {String} mode min|max
         * @param {String} property width|height
         * @param {String} value
         */
        this.queueQuery = function(selector, mode, property, value) {
            var query;
            if (document.querySelectorAll.bind) query = document.querySelectorAll.bind(document);
            if (!query && 'undefined' !== typeof $$) query = $$;
            if (!query && 'undefined' !== typeof jQuery) query = jQuery;

            if (!query) {
                throw 'No document.querySelectorAll, jQuery or Mootools\'s $$ found.';
            }

            var elements = query(selector);
            for (var i = 0, j = elements.length; i < j; i++) {
                _this.setupElement(elements[i], {
                    mode: mode,
                    property: property,
                    value: value
                });
            }
        };

        var regex = /,?([^,\n]*)\[[\s\t]*(min|max)-(width|height)[\s\t]*[~$\^]?=[\s\t]*"([^"]*)"[\s\t]*]([^\n\s\{]*)/mgi;

        /**
         * @param {String} css
         */
        this.extractQuery = function(css) {
            var match;
            css = css.replace(/'/g, '"');
            while (null !== (match = regex.exec(css))) {
                if (5 < match.length) {
                    _this.queueQuery(match[1] || match[5], match[2], match[3], match[4]);
                }
            }
        };

        /**
         * @param {CssRule[]|String} rules
         */
        this.readRules = function(rules) {
            var selector = '';
            if (!rules) {
                return;
            }
            if ('string' === typeof rules) {
                rules = rules.toLowerCase();
                if (-1 !== rules.indexOf('min-width') || -1 !== rules.indexOf('max-width')) {
                    _this.extractQuery(rules);
                }
            } else {
                for (var i = 0, j = rules.length; i < j; i++) {
                    if (1 === rules[i].type) {
                        selector = rules[i].selectorText || rules[i].cssText;
                        if (-1 !== selector.indexOf('min-height') || -1 !== selector.indexOf('max-height')) {
                            _this.extractQuery(selector);
                        }else if(-1 !== selector.indexOf('min-width') || -1 !== selector.indexOf('max-width')) {
                            _this.extractQuery(selector);
                        }
                    } else if (4 === rules[i].type) {
                        _this.readRules(rules[i].cssRules || rules[i].rules);
                    }
                }
            }
        };

        /**
         * Creates a CORS XHR
         * 
         * @param {String} method for request: GET|POST|...
         * @param {String} url of the cross domain resource
         * @return {XMLHttpRequest}
         * 
         */
        this.createCORSRequest = function(method, url) {
            var xhr = new XMLHttpRequest();
            // Chrome/Firefox/Opera/Safari.
            if ("withCredentials" in xhr) {
                xhr.open(method, url, true);
            }
            // XDomainRequest for IE.
            else if (typeof XDomainRequest != "undefined") {
                xhr = new XDomainRequest();
                xhr.open(method, url);
            }
            // CORS not supported.
            else {
                xhr = null;
            }
            return xhr;
        };
        
        // insert a DOM node after another one.
        this.insertAfter = function(newElement, targetElement) {
            var parent = targetElement.parentNode;
            if(parent.lastchild == targetElement) {
                parent.appendChild(newElement);
            }
            else {
                parent.insertBefore(newElement, targetElement.nextSibling);
            }
        };
        
        
        /**
         * Makes a CORS XHR to re-fetch a cross-domain external stylesheet 
         * so that we can gain access to its cssRules.
         * 
         * @param {Object} a stylesheet object from document.styleSheets that has a null cssRules property
         */
        this.injectStylesheet = function(styleSheet) {
            if ( ! styleSheet || ! styleSheet.href ) {
                return false;
            }
            
            // make sure we only make a single XHR request per stylesheet
            if ( _this.loading.indexOf(styleSheet.href) == -1 ) {
                _this.loading.push(styleSheet.href);
                
                var xhr = _this.createCORSRequest('GET', styleSheet.href);
                if ( ! xhr ) {
                    return false;
                }
                
                var link = styleSheet.ownerNode;
                
                xhr.onload = function() {
                    var styleNode = document.createElement('style');
                    styleNode.textContent = xhr.responseText;
                    _this.insertAfter(styleNode, link);
//                    document.head.appendChild(styleNode);
                    // remove the original stylesheet link from the DOM
                    document.head.removeChild(link);
                };
                xhr.onerror = function() {
//                    console.error('AJAX CORS request failed');
                };
                
                xhr.send();
            }
        };
        
        
        
        /**
         * Searches all css rules and setups the event listener to all elements with element query rules..
         *
         * @param {Boolean} withTracking allows and requires you to use detach, since we store internally all used elements
         *                               (no garbage collection possible if you don not call .detach() first)
         */
        this.init = function(withTracking) {
            this.withTracking = withTracking;
            for (var i = 0, j = document.styleSheets.length; i < j; i++) {
                
                var styleSheet = document.styleSheets[i];
                
                // OK to read rules for inline styles
                // and for any external stylesheets that we don't have rules for yet.
                if ( ! styleSheet.href || (_this.styleSheets.indexOf(styleSheet.href) == -1) ) {
                    // keep track of inline styles, just in case
                    if ( ! styleSheet.href ) {
                        
                    }
                    try {
                        var rules = styleSheet.cssText || styleSheet.cssRules || styleSheet.rules;
                        if ( rules ) {
                            if ( styleSheet.href && /ihouseprd|ihousedev/i.test(styleSheet.href) && ! /ckeditor/i.test(styleSheet.href) ) {
                                // keep track of loaded external stylesheets with accessible cssRules
                                _this.styleSheets.push(styleSheet.href);
                            }
                            _this.readRules(rules);
                        }
                        else {
                            // Even with the appropriate CORS headers set, Safari does not give us access to
                            // the cssRules property for external stylesheets - it is always set to null -
                            // so we re-request and inject them via XHR.
                            if ( /KHTML|WebKit|iCab/i.test(window.navigator.userAgent) ) {
                                // Note that this will only work with stylesheets that have been rebased to use
                                // absolute URLs for background-images and any other static resources that they reference.
                                if ( styleSheet.href && /ihouseprd|ihousedev/i.test(styleSheet.href)  && ! /ckeditor/i.test(styleSheet.href)  ) {
                                    _this.injectStylesheet(styleSheet);
                                }
                            }
                        }
                    } catch(e) {
                        if (e.name !== 'SecurityError') {
//                            console.error(e);
                            throw e;
                        }
                    }
                }
            }
        };

        /**
         *
         * @param {Boolean} withTracking allows and requires you to use detach, since we store internally all used elements
         *                               (no garbage collection possible if you do not call .detach() first)
         */
        this.update = function(withTracking) {
            this.withTracking = withTracking;
            this.init();
        };

        this.detach = function() {
            if (!this.withTracking) {
                throw 'withTracking is not enabled. We cannot detach elements since we do not store it.' +
                'Use ElementQueries.withTracking = true; before domready.';
            }

            var element;
            while (element = _this.elements.pop()) {
                ElementQueries.detach(element);
            }

            _this.elements = [];
        };
    };

    /**
     *
     * @param {Boolean} withTracking allows and requires you to use detach, since we store internally all used elements
     *                               (no garbage collection possible if you don not call .detach() first)
     */
    ElementQueries.update = function(withTracking) {
        ElementQueries.instance.update(withTracking);
    };

    /**
     * Attach the ResizeSensor manually
     *
     * Usage:
     *      ElementQueries.attach('my-selector', 'min-width', '400px');
     *          or
     *      ElementQueries.attach('my-selector', {
     *          'min-width': '400px',
     *          'min-height': '90px'
     *      });
     *
     * @param selector
     * @param {string|object} property
     * @param {string|undefined} value
     */
    ElementQueries.attach = function(selector, property, value) {
        var properties = property;

        if (typeof properties !== 'object') {
            properties = {};
            properties[property] = value;
        }

        for (var i in properties) {
            if (!/^(min|max)-(width|height)$/.test(i)) {
                continue;
            }

            property = i.split('-');

            ElementQueries.instance.queueQuery(selector, property[0], property[1], properties[i]);
        }
    };

    /**
     * Removes all sensor and elementquery information from the element.
     *
     * @param {HTMLElement} element
     */
    ElementQueries.detach = function(element) {
        if (element.elementQueriesSetupInformation) {
            element.elementQueriesSensor.detach();
            delete element.elementQueriesSetupInformation;
            delete element.elementQueriesSensor;
//            console.log('detached');
        } else {
//            console.log('detached already', element);
        }
    };

    ElementQueries.withTracking = false;

    ElementQueries.init = function() {
        
        if (!ElementQueries.instance) {
            ElementQueries.instance = new ElementQueries();
        }

        ElementQueries.instance.init(ElementQueries.withTracking);
    };

    var domLoaded = function (callback) {
        /* Internet Explorer */
        /*@cc_on
        @if (@_win32 || @_win64)
            document.write('<script id="ieScriptLoad" defer src="//:"><\/script>');
            document.getElementById('ieScriptLoad').onreadystatechange = function() {
                if (this.readyState == 'complete') {
                    callback();
                }
            };
        @end @*/
        /* Mozilla, Chrome, Opera */
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', callback, false);
        }
        /* Safari, iCab, Konqueror */
        if (/KHTML|WebKit|iCab/i.test(navigator.userAgent)) {
            var DOMLoadTimer = setInterval(function () {
                if (/loaded|complete/i.test(document.readyState)) {
                    callback();
                    clearInterval(DOMLoadTimer);
                }
            }, 10);
        }
        /* Other web browsers */
        window.onload = callback;
    };

    if (window.addEventListener) {
        window.addEventListener('load', ElementQueries.init, false);
    } else {
        window.attachEvent('onload', ElementQueries.init);
    }
    domLoaded(ElementQueries.init);

})();
